import { DIFFICULTY_MAX_LENGTH } from './types';
import type { DemandFormData, DemandFormErrors, DemandFormField } from './types';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const REQUIRED_SELECTS: DemandFormField[] = [
  'segment',
  'stores',
  'skus',
  'sales_history',
  'stock_control',
];

/** Ordem de foco quando a validação falha. */
export const FIELD_ORDER: DemandFormField[] = [
  'full_name',
  'email',
  'company',
  'segment',
  'stores',
  'skus',
  'sales_history',
  'stock_control',
  'difficulty',
  'consent_accepted',
];

export function validateDemandForm(data: DemandFormData): DemandFormErrors {
  const errors: DemandFormErrors = {};

  if (!data.full_name.trim()) errors.full_name = 'Informe seu nome';
  if (!data.email.trim()) {
    errors.email = 'Informe seu e-mail';
  } else if (!EMAIL_PATTERN.test(data.email.trim())) {
    errors.email = 'Informe um e-mail válido';
  }
  if (!data.company.trim()) errors.company = 'Informe o nome da empresa';

  REQUIRED_SELECTS.forEach((field) => {
    if (!data[field]) errors[field] = 'Selecione uma opção';
  });

  if (data.difficulty.length > DIFFICULTY_MAX_LENGTH) {
    errors.difficulty = `Máximo de ${DIFFICULTY_MAX_LENGTH} caracteres`;
  }

  if (!data.consent_accepted) {
    errors.consent_accepted = 'É necessário autorizar o uso dos dados';
  }

  return errors;
}
